"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCompactNumber = void 0;
const getSeparatedByThousands_1 = require("./getSeparatedByThousands");
const getCompactNumber = (value) => {
    if (value.toString().length < 5) {
        return {
            displayedValue: getSeparatedByThousands_1.getSeparatedByThousands(value),
            actualValue: null,
        };
    }
    return {
        displayedValue: `${Math.round(value / 1000)}K`,
        actualValue: getSeparatedByThousands_1.getSeparatedByThousands(value),
    };
};
exports.getCompactNumber = getCompactNumber;
//# sourceMappingURL=getCompactNumber.js.map